import * as React from "react";
import { connect } from "react-redux";
import { RouteComponentProps } from "react-router";
import { Action, Dispatch } from "redux";
import { frontEndConfig } from "../../config/config";
import { Pager } from "../../domain/model/common";
import { Company } from "../../domain/model/company";
import { Project } from "../../domain/model/project";
import { createClientProjectListActionCreator } from "../action/client_projects_action";
import ProjectsComponent from "../component/client/projects/client_projects";
import {
  createClientProjectListDispatcher,
  IClientProjectListDispatcher,
} from "../dispatcher/client_projects_dispatcher";
import {
  CopyProjectRequest,
  GetAllProjectListByClientRequest,
} from "../request/project_request";
import { AppState } from "../store/app_state";
import { ClientProjectListState } from "../store/client_projects_state";
import { TPagination } from "../type/common";

const defaultOffset = frontEndConfig.defaultOffset;
const pageRangeDisplayed: number = frontEndConfig.defaultPageRangeDisplayed;

interface IProps extends RouteComponentProps<{}> {
  state: ClientProjectListState;
  dispatcher: IClientProjectListDispatcher;
}

interface IState {
  isInit: boolean;
}

export class ClientProjects extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      isInit: true,
    };
  }

  public componentDidMount() {
    // 直接アクセスの際のデータ取得
    const params: { activePage: number } = this.helperForSearchPrams(
      this.props.location.search
    );
    this.pushQueryString(params.activePage);
  }

  public componentWillReceiveProps(
    nextProps: Readonly<IProps>,
    nextContext: any
  ): void {
    // URL遷移の際のデータ取得
    if (nextProps.location !== this.props.location) {
      const params: { activePage: number } = this.helperForSearchPrams(
        nextProps.location.search
      );
      const pager: Pager = new Pager(params.activePage, defaultOffset);
      const req: GetAllProjectListByClientRequest =
        new GetAllProjectListByClientRequest();
      req.pager = pager;
      this.props.dispatcher.getAllByClientProjectList(req);
    }
  }

  public onCopy(projectId: string): void {
    const req = new CopyProjectRequest();
    req.projectId = projectId;
    this.props.dispatcher.copy(req);
  }

  public componentDidUpdate(prevProps: IProps, prevState: IState) {
    // init処理の終了
    const isInitFinished: boolean =
      this.state.isInit &&
      !this.props.state.isLoading &&
      prevProps.state.isLoading;
    if (isInitFinished) {
      return this.setState({ isInit: false });
    }
  }

  public render(): JSX.Element {
    const { location, state } = this.props;
    const { isInit } = this.state;

    const projects: Project[] = state.projects;
    const projectCount: number = state.projectCount;
    const companies: Company[] = state.companies;

    const totalItemsCount: number = state.projectCount;
    const isLoading: boolean = state.isLoading;
    const itemsCountPerPage: number = defaultOffset;

    const params: { activePage: number } = this.helperForSearchPrams(
      location.search
    );

    const paginationPrams: TPagination = {
      activePage: params.activePage,
      itemsCountPerPage,
      totalItemsCount,
      pageRangeDisplayed,
      onChange: this.handlePageChange,
    };

    return (
      <ProjectsComponent
        isInit={isInit}
        isLoading={isLoading}
        projects={projects}
        projectCount={projectCount}
        companies={companies}
        paginationPrams={paginationPrams}
        onCopy={(projectId: string) => this.onCopy(projectId)}
      />
    );
  }

  private helperForSearchPrams = (
    urlSearchParams: any
  ): { activePage: number } => {
    const params = new URLSearchParams(urlSearchParams);
    let activePage: number = params.get("p") ? Number(params.get("p")) : 1;
    if (Number.isNaN(activePage)) {
      activePage = 1;
    }

    const res: { activePage: number } = {
      activePage,
    };
    return res;
  };

  private pushQueryString = (activePage: number): void => {
    const { location, history } = this.props;
    const params = new URLSearchParams(location.search);
    params.set("p", activePage.toString());
    history.push({
      search: params.toString(),
    });
  };

  private handlePageChange = (pageNumber: number): void => {
    this.pushQueryString(pageNumber);
  };
}

const mapStateToProps = (state: AppState) => {
  return {
    state: state.clientProjectListReducer,
  };
};

const mapDispatchToProps = (dispatch: Dispatch<Action>) => {
  return {
    dispatcher: createClientProjectListDispatcher(
      dispatch,
      createClientProjectListActionCreator()
    ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ClientProjects);



// WEBPACK FOOTER //
// ./src/presentation/container/client_projects_container.tsx